import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CIVIL_STATUSES, GENDERS, LICENSE_TYPES, OTHER_CIVIL_STATUSES } from '../../utils/constants';
import { Option } from '../../utils/types';
import CustomValidators from 'src/utils/validators';
import { WebServicesService } from '../web-services.service';


export class DriverForm extends FormGroup {
  constructor() {
    super({
      sex: new FormControl(null, CustomValidators.notNull),
      marital: new FormControl(null, Validators.required),
      age: new FormControl('', [Validators.required, CustomValidators.number, Validators.min(18)]),
      zip_code: new FormControl(''),
      license_type: new FormControl('', Validators.required),
      discount_code: new FormControl(''),
      discount_code_is_valid: new FormControl(''),
    });
  }
}

@Component({
  selector: 'app-driver-form',
  templateUrl: './driver-form.component.html',
  styleUrls: ['./driver-form.component.scss'],
})
export class DriverFormComponent {
  constructor(
    private webServices: WebServicesService,
  ) {}
  @Input() form: DriverForm;
  @Input() showZipCode: boolean;
  checkingCodeLoading = false;
  discount_code_is_valid = false;
  first_click = false;
  discount_code = '';

  genders: Option[] = GENDERS;
  civilStatuses: Option[] = CIVIL_STATUSES;
  otherCivilStatuses: Option[] = OTHER_CIVIL_STATUSES;
  licenseTypes: Option[] = LICENSE_TYPES;

  shouldShowOtherCivilStatuses() {
    const value = this.form.get('marital').value;
    return value !== 'M' && value !== 'S' && value !== null;
  }

  checkDiscountCode() {
    const discount_code = this.form.get('discount_code');
    this.discount_code = discount_code.value.toUpperCase( )
    this.checkingCodeLoading = true;
    this.first_click = true;
    this.webServices.checkDiscountCode(discount_code.value).subscribe(
      ({ valid , code }) => {
        this.checkingCodeLoading = false;
        this.discount_code_is_valid = valid;
        this.discount_code = code;
        this.form.get('discount_code_is_valid').setValue(valid);
        this.form.get('discount_code').setValue(code);
      },
    );
  }
}
